
import React from 'react'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import CHero from '../Common/CHero'
import { FiPhone } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { RxEnvelopeClosed } from "react-icons/rx";
import { FaRegClock } from "react-icons/fa6";
import img from "../../assets/close-up-person-working-call-center 4con.png"
import ContactForm from './ContactForm';
import ContactHero from './ContactHero';

const Contact = () => {
  return (
    <>
    <Nav />
    
    <section className='flex md:flex-col md:w-[90%] w-[90%] pt-[150px] md:pt-[90px] mx-auto '>
      <div className='bar p-0 bg-[#DDD9F8]'>
        <img src={img} className='rounded-[100px] sm:h-[400px] sm:object-coer h-[600px]' alt="close-up-person-working-call-center" />
      </div>
      <div className='my-auto w-[50%] md:mt-5 md:w-full flex flex-col justify-center items-start mx-auto sm:pl-0 pl-28'>
        <h2 className='text-4xl font-bold text-[#4B4B4B] md:text-[32px]'>Get in touch with us</h2>
        <p className='text-[#555454] font-normal text-base mt-2 mb-8'>
        Connect with us and lets shape your educational pathway together.
        </p>
        <div className='mb-5'>
                <div className='flex'>
<span className='bg-[#F1EFFF] w-[80px] md:w-[70px] md:h-[70px] h-[80px] flex justify-center items-center rounded-full'>
<FiPhone color='#5E4FAC' className='w-[33px] md:w-[30px] md:h-[30px] h-[33px] '  />
</span>
<div className='ml-4 md:w-[80%]'>
    <h2 className='text-[#000000] font-medium text-2xl mb-3'>Call Us</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    (+234) 815 6955508,  (+234) 815 5768004
    </p>
    
</div>
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex'>
                <span className='bg-[#F1EFFF] w-[80px] md:w-[70px] md:h-[70px] h-[80px] flex justify-center items-center rounded-full'>
<HiOutlineLocationMarker color='#5E4FAC' className='w-[33px] md:w-[30px] md:h-[30px] h-[33px] '  />
</span>
<div className='ml-4 w-[80%]'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Location</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    5, Agbon road, Iyano church, Ibadan.
    </p>
    <p className='text-[#656363] font-medium text-base  -[70%]'>
    8, Agbon road, Iyano church, Ibadan, Oyo state, Nigeria
    </p>
</div>
                </div>
            </div>
            <div className='mb-5'>
                <div className='flex'>
                <span className='bg-[#F1EFFF] w-[80px] md:w-[70px] md:h-[70px] h-[80px] flex justify-center items-center rounded-full'>
<RxEnvelopeClosed color='#5E4FAC' className='w-[33px] md:w-[30px] md:h-[30px] h-[33px]'  /></span>
<div className='ml-4  w-[80%]'>
    <h2 className='text-[#000000] font-medium text-2xl mb-4'>Email Address</h2>
    <p className='text-[#656363] font-medium text-base mb-2'>
    quest-inspireeduconsult@yahoo.com
    </p>
    
</div>
                </div>
            </div>
      </div>
    </section>
    <ContactForm />
    <Footer />
    </>
  )
}

export default Contact